import { Notification } from '@lib/components/Notification'
import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import { openModal } from '@storeOld/reducers/ui'
import { useDispatch, useSelector } from 'react-redux'

import { useAuth } from '@/hooks/useAuth'
import { MODAL_PRICING } from '../../Modal/constants'

const StorageBadge = () => {
  const dispatch = useDispatch()
  const auth = useAuth()

  const { quota } = useSelector(migrationProjectSelector.getProjectStorage)
  const projectId = useSelector(migrationProjectSelector.getProjectId)
  const owner = useSelector(
    migrationProjectSelector.getIsCurrentUserOwnerOfProject
  )

  const onClickUpgrade = () => {
    dispatch(openModal(MODAL_PRICING))
  }

  if (
    !auth.authenticated ||
    !quota ||
    quota.projectId !== projectId ||
    quota.limits.percentageUsage < 85
  ) {
    return null
  }

  const storageLimits = quota.limits
  const upgradeProps = owner
    ? { onClick: onClickUpgrade, actionText: 'Upgrade' }
    : {}
  const ownerHint = owner ? '' : ' Contact the project owner to free up space.'
  const subject = owner ? 'Your storage' : "Project owner's storage"

  if (storageLimits.usage < storageLimits.max) {
    return (
      <div className="Tree-storage-badge">
        <Notification
          type="orange"
          text={`${subject} is almost full: ${storageLimits.hUsage} of ${storageLimits.hMax} used.${ownerHint}`}
          {...upgradeProps}
        />
      </div>
    )
  }

  return (
    <div className="Tree-storage-badge">
      <Notification
        type="coral"
        text={`${subject} is full: ${storageLimits.hUsage} of ${storageLimits.hMax} used.${ownerHint}`}
        {...upgradeProps}
      />
    </div>
  )
}

export default StorageBadge
